var map = {
	"./language_en.properties": "Bmsd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GWwm";


//////////////////
// WEBPACK FOOTER
// ./src ^\.\/language_.*\.properties$
// module id = GWwm
// module chunks = 1